import { useState, useEffect } from "react";
import axiosInstance from "../../../utility/axiosInstance";
import { CandidateInterview } from "../../../store/types/candidate";

interface UseRecentInterviewsReturn {
  interviews: CandidateInterview[];
  loading: boolean;
  error: string | null;
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
  };
  fetchRecentInterviews: (page?: number, pageSize?: number) => Promise<void>;
}

export const useRecentInterviews = (): UseRecentInterviewsReturn => {
  const [interviews, setInterviews] = useState<CandidateInterview[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    pageSize: 10,
  });

  const fetchRecentInterviews = async (page = 1, pageSize = 10) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axiosInstance.get(
        `/interviews/recent?pageSize=${pageSize}&page=${page}`,
      );

      if (response.data?.success === true) {
        const data = response.data.data;
        const totalItems = response.data.count || 0;
        setInterviews(Array.isArray(data) ? data : []);
        setPagination({
          currentPage: page,
          totalPages: Math.ceil(totalItems / pageSize) || 1,
          totalItems: totalItems,
          pageSize: pageSize,
        });
      } else {
        setError("Failed to fetch recent interviews");
      }
    } catch (err: any) {
      console.error("Error fetching recent interviews:", err);
      setError(
        err.response?.data?.message || "Failed to fetch recent interviews",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRecentInterviews();
  }, []);

  return {
    interviews,
    loading,
    error,
    pagination,
    fetchRecentInterviews,
  };
};
